import { useCallback, useState } from "react"
import {
  ROUTE_TRAFFIC_OFF,
  RouteTrafficSettings,
} from "@/components/maps/routeTraffic"

export const ROUTE_TRAFFIC_STORAGE_KEY = "routeTraffic.settings"

function readSettings(): RouteTrafficSettings {
  try {
    const stored = JSON.parse(
      localStorage.getItem(ROUTE_TRAFFIC_STORAGE_KEY) ?? "null",
    )
    if (
      stored &&
      typeof stored.colors === "boolean" &&
      Array.isArray(stored.incidentTypes)
    ) {
      return {
        colors: stored.colors,
        incidentTypes: stored.incidentTypes.filter(
          (type: unknown): type is string => typeof type === "string",
        ),
      }
    }
  } catch {
    // A broken value falls back to everything off
  }
  return ROUTE_TRAFFIC_OFF
}

/** The traffic menu's choices, remembered in this browser. */
export function useRouteTrafficSettings(): [
  RouteTrafficSettings,
  (settings: RouteTrafficSettings) => void,
] {
  const [settings, setSettings] = useState(readSettings)

  const update = useCallback((next: RouteTrafficSettings) => {
    setSettings(next)
    localStorage.setItem(ROUTE_TRAFFIC_STORAGE_KEY, JSON.stringify(next))
  }, [])

  return [settings, update]
}
